import React, { useState } from "react";
import { Container, Button, Modal, Nav } from "react-bootstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";

const LoginAskModal = (props) => {
    const { showLoginAskModal, handleCloseLoginAskModal } = props;
    const [activeTab, setActiveTab] = useState("Desktop");
    const navigate = useNavigate();
    return (
        <Container>
            {/* Modal for Viewing Template */}
            <Modal
                show={showLoginAskModal}
                onHide={handleCloseLoginAskModal}
                centered
                // size={activeTab === "Desktop" ? "xl" : "md"} // Set modal size based on active tab
                size='md'
            >
                <div style={{background: '#fff', borderRadius: 15}}                >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h6>You need to login first to edit this template.</h6>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={handleCloseLoginAskModal}>
                        Cancel
                    </Button>
                    <Button variant="primary" size="sm" onClick={()=>navigate("/login")}>
                        Login
                    </Button>
                </Modal.Footer>
                
                </div>
            </Modal>
        </Container >
    );
};

export default LoginAskModal;